<template>
  <div class="t-select" :class="[{ invalid: error }]">
    <label>
      <div v-if="label" class="t-input__label">{{ label }}</div>
      <div class="t-select__native-select-container">
        <select
          v-model="model"
          :class="[{ 't-select__safari-placeholder': isSafari && !model && placeholder }]"
        >
          <option v-if="isSafari" :value="null" disabled>{{ placeholder }}</option>
          <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            :disabled="option.disabled"
          >
            {{ option.text }}
          </option>
        </select>
        <div v-if="!model && placeholder && !isSafari" class="t-select__placeholder">
          {{ placeholder }}
        </div>
      </div>
    </label>
    <div v-if="error && errorMessage" class="t-input__error-message">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { isSafari } from 'Utilities'

export default {
  name: 'TSelect',

  props: {
    value: [String, Number, null],
    label: [String, Number, null],
    placeholder: [String, Number, null],
    error: Boolean,
    errorMessage: [String, Number, null],
    options: { type: Array, default: () => [] }
  },

  data() {
    return {
      isSafari: isSafari()
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
